export default "__VITE_ASSET__9547829c__"